import React, { useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";

const Header = () => {
  return (
    <>
      <div className="py-4 flex justify-center gap-2 px-5 items-center ">
        <Reveal head>
          <Link
            to="https://www.filetrust.io"
            className="flex items-center text-white gap-3 text-[30px]"
          >
            <img src="/logo.png" className="w-12 lg:w-14" alt="Logo" />
            <h1>FileTrust</h1>
          </Link>
        </Reveal>
      </div>
    </>
  );
};

export default Header;
